export const environment = {
  production: false,
  disableHostCheck: true,
  APIENDPOINT: 'https://workroo-dev-env-api.23jh68hqd51w4.ap-southeast-2.cs.amazonlightsail.com/api/v0.1',
  SUPPORTFILEBASEPATH: 'https://s3-ap-southeast-2.amazonaws.com/workroo-media-dev'
};
